import React, { useCallback, useEffect, useRef, useState } from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../Theme'
import { Cancel, Search } from 'iconoir-react'

const SearchBoxWrapper = styled.div`
   width: 100%;
   margin-bottom: 1rem;

   &.topSpace {
      padding: 1rem 0 0 0;
   }

   .searchbox-container {
      display: flex;
      align-items: center;
      width: 100%;
      position: relative;
   }

   .searchbox-input {
      border: 2px solid var(--color-vb-blue) !important;
      border-radius: 50px;
      width: 100%;
      padding: 10px 75px 10px 15px;
      border: 2px solid ${theme.colors.greyMedium};
      box-sizing: border-box;
      font-family: var(--font-industry);
      font-weight: 500;
      font-size: 1rem;
      line-height: normal;
      box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.04);
      &::-webkit-search-cancel-button {
         -webkit-appearance: none;
      }
   }

   .searchbox-input:focus {
      /* border: 2px solid var(--color-vb-blue); */
      outline: none;
   }

   .searchbox-reset {
      position: absolute;
      right: 60px;
      width: 20px;
      height: 20px;
      background: white;
      border: none;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-vb-blue);
   }

   .searchbox-icon {
      position: absolute;
      right: 5px;
      width: 50px;
      height: 35px;
      background: var(--color-vb-blue);
      border: 2px solid var(--color-vb-blue);
      border-radius: 50px;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
   }

   .searchbox-input:not(:has(+ .searchbox-reset)) {
      padding-right: 60px;
   }
`

const SearchBox = ({
   placeholder,
   topSpace,
   onSearchChange,
   searchValue: externalSearchValue,
   setSearchValue: externalSetSearchValue,
}) => {
   const [internalSearchValue, setInternalSearchValue] = useState('')
   // Use external or internal state based on whether props were provided
   const searchValue =
      externalSearchValue !== undefined
         ? externalSearchValue
         : internalSearchValue
   const setSearchValue = externalSetSearchValue || setInternalSearchValue

   const timeoutId = useRef(null)

   const handleDebouncedSearch = useCallback(
      value => {
         if (timeoutId.current) {
            clearTimeout(timeoutId.current)
         }
         timeoutId.current = setTimeout(() => {
            onSearchChange?.(value)
         }, 300)
      },
      [onSearchChange]
   )

   const handleInputChange = e => {
      const newValue = e.target.value
      setSearchValue?.(newValue)
      handleDebouncedSearch(newValue)
   }

   const handleReset = () => {
      setSearchValue?.('')
      onSearchChange?.('')
   }

   useEffect(() => {
      return () => {
         if (timeoutId.current) {
            clearTimeout(timeoutId.current)
         }
      }
   }, [])

   return (
      <SearchBoxWrapper
         className={topSpace ? 'topSpace' : ''}
      >
         <div className="searchbox-container">
            <input
               className="searchbox-input"
               type="search"
               value={searchValue}
               onChange={handleInputChange}
               placeholder={placeholder}
            />
            {searchValue && (
               <button
                  className="searchbox-reset"
                  onClick={handleReset}
                  type="button"
               >
                  <Cancel strokeWidth={3} />
               </button>
            )}
            <button className="searchbox-icon">
               <Search strokeWidth={2} />
            </button>
         </div>
      </SearchBoxWrapper>
   )
}

export default SearchBox
